import React from 'react'
import { Tooltip, Typography } from '@mui/material'
import HelpButton from './HelpButton'

const NaidesuHelp = ({ size }) => {
  const tooltip = (
    <>
      <Typography variant="body2">
        ポイントが高いほど解答権を取りにくくなります.
      </Typography>
    </>
  )

  return (
    <Tooltip title={tooltip}>
      <span>
        <HelpButton size={size} />
      </span>
    </Tooltip>
  )
}

export default NaidesuHelp
